import { render, staticRenderFns } from "./FeedBackList.vue?vue&type=template&id=e4a0fa2a&scoped=true"
import script from "./FeedBackList.vue?vue&type=script&lang=js"
export * from "./FeedBackList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a0fa2a",
  null
  
)

export default component.exports